import { consoleHandlerError } from "@/utils/message";

var socket = null;
var socketTimeout = null;

const WebSocket = {
    socketTimeout: socketTimeout,
    socket: socket,
    responseMessage: {
        complete_transaction: false,
    },

    disconnect(obj) {
        obj.responseMessage = {
            ...obj.responseMessage,
            complete_transaction: true,
        };
        if (socket) clearInterval(socket);
        if (socketTimeout) clearTimeout(socketTimeout);
        console.info("websocket disconnected");
    },

    sendMessage(endpoint, params, obj) {
        endpoint(params)
            .then((response) => {
                obj.responseMessage = response.data;
                this.responseMessage = obj.responseMessage;
                if (obj.responseMessage.complete_transaction === true)
                    obj.disconnect(obj);
            })
            .catch((error) => {
                obj.disconnect(obj);
                consoleHandlerError({
                    error,
                    empty: true,
                });
            });

        this.disconnect = obj.disconnect;
    },

    connect(endpoint, params = {}, timeout = 300000) {
        this.responseMessage = {
            complete_transaction: false,
        };
        socketTimeout = setTimeout(this.disconnect, timeout, this);
        socket = setInterval(this.sendMessage, 5000, endpoint, params, this);
        console.info("websocket connected");
    },
};

export default WebSocket;
